import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import LoadingPopup from "./loading";
import { secretKey } from "./data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LeadDetail from "./leadDetail";

const MySwal = withReactContent(Swal2);

const SendClientsConf = (props) => {
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);
  const [showAddClient, setShowAddClient] = useState(false);
  const [showEditClient, setShowEditClient] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyMail, setCompanyMail] = useState("");
  const [companyPrice, setCompanyPrice] = useState("");
  const [companyType, setCompanyType] = useState("CHF");
  const [companyActive, setCompanyActive] = useState("1");
  const [companyId, setCompanyId] = useState("");
  const [sendType, setSendType] = useState("CHF");

  const fetchClients = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getSendClientsConf", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClients(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const editClientF = async () => {
    if (
      companyName &&
      companyMail &&
      companyActive &&
      companyPrice &&
      companyType
    ) {
      var body = {
        name: companyName,
        mail: companyMail,
        price: companyPrice,
        company: companyType,
        active: companyActive,
        id: companyId,
      };

      await fetch("https://apisellcrm.ftpeople.pl/editSendClientsConf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "klienta",
          }).then(async (result) => {
            getData();
            setShowEditClient(false);
            setCompanyActive("1");
            setCompanyMail("");
            setCompanyName("");
            setCompanyPrice("");
            setCompanyType("CHF");
            setCompanyId("");
          });
        })
        .catch((error) => {});
    }
  };

  const editClientBody = (
    <div
      style={{
        position: "absolute",
        top: "5vh",
        left: "5vw",
        width: "50vw",
        height: "35vh",
        overflowY: "scroll",
        backgroundColor: "white",
        borderRadius: "15px",
        boxShadow: "8px 8px 24px 0px rgba(66, 68, 90, 1)",
        textAlign: "left",
        padding: "2%",
      }}
    >
      <div style={{ display: "flex", marginBottom: "3vh" }}>
        <div
          style={{
            width: "85%",
            textAlign: "left",
            fontWeight: "600",
            fontSize: "2vw",
          }}
        >
          EDYTUJ KLIENTA
        </div>
        <div style={{ width: "15%" }}>
          <button
            className="loginButtonLogin"
            value="yes"
            style={{
              margin: "0",
              backgroundColor: "navy",
              borderColor: "navy",
              width: "100%",
            }}
            onClick={() => {
              setShowAddClient(false);
            }}
          >
            X
          </button>
        </div>
      </div>
      <div style={{ display: "flex", gap: "50px" }}>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            nazwa <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </div>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            adres e-mail <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyMail}
            onChange={(e) => setCompanyMail(e.target.value)}
          />
        </div>
      </div>
      <div style={{ display: "flex", gap: "50px", marginTop: "2vh" }}>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            cena <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="number"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyPrice}
            onChange={(e) => setCompanyPrice(e.target.value)}
          />
        </div>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            aktywna <span style={{ color: "red" }}>*</span>
          </p>
          <select
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyActive}
            onChange={(e) => setCompanyActive(e.target.value)}
          >
            <option key={0} value={"1"}>
              TAK
            </option>
            <option key={1} value={"0"}>
              NIE
            </option>
          </select>
        </div>
      </div>
      <div style={{ display: "flex", gap: "50px", marginTop: "2vh" }}>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            rodzaj leadów <span style={{ color: "red" }}>*</span>
          </p>
          <select
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyType}
            onChange={(e) => setCompanyType(e.target.value)}
          >
            <option key={0} value={"CHF"}>
              CHF
            </option>
            <option key={1} value={"SKD"}>
              SKD
            </option>
            <option key={2} value={"WIBOR"}>
              WIBOR
            </option>
          </select>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: "3vh" }}>
        <div
          style={{
            width: "85%",
            textAlign: "left",
            fontWeight: "600",
            fontSize: "2vw",
          }}
        ></div>
        <div style={{ width: "auto" }}>
          <button
            className="loginButtonLogin"
            value="yes"
            style={{
              margin: "0",
              backgroundColor: "green",
              borderColor: "green",
              width: "100%",
              textAlign: "center",
            }}
            onClick={() => {
              editClientF();
            }}
          >
            EDYTUJ
          </button>
        </div>
      </div>
    </div>
  );

  const clientsBody = (
    <>
      <table
        style={{ marginTop: "3vh", fontSize: ".8vw" }}
        className="clients_table"
      >
        <tr key={0}>
          <th>nazwa</th>
          <th>mail</th>
          <th>cena</th>
          <th>dział</th>
          <th>aktywny</th>
          <th>akcja</th>
        </tr>
        {clients
          .filter((ep) => ep.company === sendType)
          .map((el, index) => (
            <>
              <tr id={""} key={el.id}>
                <td>{el.name}</td>
                <td>{el.mail}</td>
                <td>{el.price} PLN</td>
                <td>{el.company}</td>
                <td>{el.active}</td>
                <td>
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "blue",
                      borderColor: "blue",
                      width: "100%",
                      padding: "5px",
                      height: "auto",
                      fontSize: ".6vw",
                    }}
                    onClick={(e) => {
                      setShowEditClient(true);
                      setCompanyName(el.name);
                      setCompanyMail(el.mail);
                      setCompanyPrice(el.price);
                      setCompanyType(el.company);
                      setCompanyActive(el.active);
                      setCompanyId(el.id);
                    }}
                  >
                    edytuj
                  </button>
                </td>
              </tr>
            </>
          ))}
      </table>
    </>
  );

  const addClientF = async () => {
    if (
      companyName &&
      companyMail &&
      companyActive &&
      companyPrice &&
      companyType
    ) {
      var body = {
        name: companyName,
        mail: companyMail,
        price: companyPrice,
        company: companyType,
        active: companyActive,
      };

      await fetch("https://apisellcrm.ftpeople.pl/addSendClientsConf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "klienta",
          }).then(async (result) => {
            getData();
            setShowAddClient(false);
            setCompanyActive("1");
            setCompanyMail("");
            setCompanyName("");
            setCompanyPrice("");
            setCompanyType("CHF");
          });
        })
        .catch((error) => {});
    }
  };

  const addClientBody = (
    <div
      style={{
        position: "absolute",
        top: "5vh",
        left: "5vw",
        width: "50vw",
        height: "35vh",
        overflowY: "scroll",
        backgroundColor: "white",
        borderRadius: "15px",
        boxShadow: "8px 8px 24px 0px rgba(66, 68, 90, 1)",
        textAlign: "left",
        padding: "2%",
      }}
    >
      <div style={{ display: "flex", marginBottom: "3vh" }}>
        <div
          style={{
            width: "85%",
            textAlign: "left",
            fontWeight: "600",
            fontSize: "2vw",
          }}
        >
          DODAJ KLIENTA
        </div>
        <div style={{ width: "15%" }}>
          <button
            className="loginButtonLogin"
            value="yes"
            style={{
              margin: "0",
              backgroundColor: "navy",
              borderColor: "navy",
              width: "100%",
            }}
            onClick={() => {
              setShowAddClient(false);
            }}
          >
            X
          </button>
        </div>
      </div>
      <div style={{ display: "flex", gap: "50px" }}>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            nazwa <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </div>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            adres e-mail <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyMail}
            onChange={(e) => setCompanyMail(e.target.value)}
          />
        </div>
      </div>
      <div style={{ display: "flex", gap: "50px", marginTop: "2vh" }}>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            cena <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="number"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyPrice}
            onChange={(e) => setCompanyPrice(e.target.value)}
          />
        </div>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            aktywna <span style={{ color: "red" }}>*</span>
          </p>
          <select
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyActive}
            onChange={(e) => setCompanyActive(e.target.value)}
          >
            <option key={0} value={"1"}>
              TAK
            </option>
            <option key={1} value={"0"}>
              NIE
            </option>
          </select>
        </div>
      </div>
      <div style={{ display: "flex", gap: "50px", marginTop: "2vh" }}>
        <div style={{ width: "45%", textAlign: "left" }}>
          <p
            style={{
              margin: "0",
              marginBottom: "10px",
              fontWeight: "600",
              fontSize: ".8vw",
            }}
          >
            rodzaj leadów <span style={{ color: "red" }}>*</span>
          </p>
          <select
            type="text"
            style={{
              width: "100%",
              padding: "0px 10px",
              boxSizing: "border-box",
            }}
            value={companyType}
            onChange={(e) => setCompanyType(e.target.value)}
          >
            <option key={0} value={"CHF"}>
              CHF
            </option>
            <option key={1} value={"SKD"}>
              SKD
            </option>
            <option key={2} value={"WIBOR"}>
              WIBOR
            </option>
          </select>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: "3vh" }}>
        <div
          style={{
            width: "85%",
            textAlign: "left",
            fontWeight: "600",
            fontSize: "2vw",
          }}
        ></div>
        <div style={{ width: "auto" }}>
          <button
            className="loginButtonLogin"
            value="yes"
            style={{
              margin: "0",
              backgroundColor: "green",
              borderColor: "green",
              width: "100%",
              textAlign: "center",
            }}
            onClick={() => {
              addClientF();
            }}
          >
            DODAJ
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div style={{ textAlign: "left", marginBottom: "2vh" }}>
            <select
              style={{ border: "1px solid gray" }}
              onChange={(e) => {
                setSendType(e.target.value);
              }}
            >
              <option key={0} value={"CHF"}>
                CHF
              </option>
              <option key={1} value={"SKD"}>
                SKD
              </option>
              <option key={2} value={"WIBOR"}>
                WIBOR
              </option>
            </select>
            <span
              style={{
                marginLeft: "10px",
                textTransform: "lowercase",
                fontSize: ".8vw",
              }}
            >
              Ilość: {clients.filter((el) => el.company === sendType).length}
            </span>
          </div>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
              }}
            >
              <button
                className="loginButtonLogin"
                style={{
                  margin: "0",
                  backgroundColor: "lavender",
                  borderColor: "lavender",
                  color: "black",
                  width: "250px",
                }}
                onClick={(e) => {
                  setShowAddClient(true);
                }}
              >
                DODAJ
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "green",
                  borderColor: "green",
                  width: "20%",
                  textAlign: "center",
                }}
                onClick={async () => {
                  var body = {
                    type: sendType,
                  };

                  await fetch(
                    "https://apisellcrm.ftpeople.pl/activateAllType",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body),
                    }
                  )
                    .then((response) => response.text())
                    .then((data) => {
                      getData();
                    })
                    .catch((error) => {});
                }}
              >
                AKTYWUJ WSZYSTKIE
              </button>
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "red",
                  borderColor: "red",
                  width: "20%",
                  textAlign: "center",
                }}
                onClick={async () => {
                  var body = {
                    type: sendType,
                  };

                  await fetch(
                    "https://apisellcrm.ftpeople.pl/deactivateAllType",
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body),
                    }
                  )
                    .then((response) => response.text())
                    .then((data) => {
                      getData();
                    })
                    .catch((error) => {});
                }}
              >
                DEAKTYWUJ WSZYSTKIE
              </button>
            </div>
          </div>
          <div>
            {showAddClient ? addClientBody : ""}
            {showEditClient ? editClientBody : ""}
            {clientsBody}
          </div>
        </>
      )}
    </div>
  );
};

export default SendClientsConf;
